// Calculs de l'itinéraire d'un voyage : ordre des étapes, jours, nuits, dates.
const DAY_MS = 24 * 60 * 60 * 1000;

// « AAAA-MM-JJ » lu en date locale (new Date(chaîne) la lirait en UTC)
export const parseDay = (value) => {
    const [y, m, d] = value.split('-').map(Number);
    return new Date(y, m - 1, d);
};

const dayNumber = (value) => {
    const d = parseDay(value);
    return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / DAY_MS;
};

export const sortStages = (places) =>
    [...places].sort((a, b) => dayNumber(a.start_date) - dayNumber(b.start_date));

export const stageDays = (place, tripStart) => {
    const first = dayNumber(place.start_date) - dayNumber(tripStart) + 1;
    const last = dayNumber(place.end_date) - dayNumber(tripStart) + 1;
    return first === last ? `Jour ${first}` : `Jours ${first} à ${last}`;
};

export const stageNights = (place) => {
    const n = dayNumber(place.end_date) - dayNumber(place.start_date);
    if (n <= 0) return null;
    return n === 1 ? '1 nuit' : `${n} nuits`;
};

const format = (value, options) =>
    new Intl.DateTimeFormat('fr-FR', options).format(parseDay(value));

const FULL = { day: 'numeric', month: 'long', year: 'numeric' };

export const formatRange = (start, end) => {
    const a = parseDay(start);
    const b = parseDay(end);
    if (start === end) return format(start, FULL);
    if (a.getFullYear() !== b.getFullYear()) return `${format(start, FULL)} – ${format(end, FULL)}`;
    if (a.getMonth() !== b.getMonth()) {
        return `${format(start, { day: 'numeric', month: 'long' })} – ${format(end, FULL)}`;
    }
    return `${a.getDate()} – ${format(end, FULL)}`;
};

// Nombre d'étapes, de jours (bornes comprises) et dates du voyage
export const tripFacts = (places) => {
    if (!places.length) return null;
    const stages = sortStages(places);
    const start = stages[0].start_date;
    const end = stages.reduce((max, p) => (dayNumber(p.end_date) > dayNumber(max) ? p.end_date : max), stages[0].end_date);
    return { stages: places.length, days: dayNumber(end) - dayNumber(start) + 1, start, end };
};
